import { useCallback } from 'react';
import { Icon } from '../../../../foundations';
import { Loader } from '../../../../foundations/Loader';
import { useMultiStyleConfig } from '../../../../utils/use-style-config';
import { InputRightElement } from '../../../internal';
import { jsx as _jsx } from "react/jsx-runtime";
export var TriggerRightElement = _ref => {
  var {
    isDisabled,
    isReadOnly,
    isViewMode,
    isLoading,
    isOpen,
    setRightElementWidth
  } = _ref;
  var rightElementRef = useCallback(el => {
    if (!el) return;
    setRightElementWidth(el.offsetWidth);
  }, // eslint-disable-next-line react-hooks/exhaustive-deps -- We nedd to recalculate when `isLoading` changes because the loader has a different width.
  [setRightElementWidth, isLoading]);
  var styles = useMultiStyleConfig('SelectNew', {});
  return /*#__PURE__*/_jsx(InputRightElement, {
    ref: rightElementRef,
    "data-component": "SelectNew.TriggerRightElement",
    sx: styles['triggerRightElement'],
    "data-readonly": isReadOnly || isLoading || isViewMode || undefined,
    "data-loading": isLoading || undefined,
    "data-view-mode": isViewMode || undefined,
    "aria-disabled": isDisabled || undefined,
    "aria-hidden": true,
    children: isLoading ? /*#__PURE__*/_jsx(Loader, {}) : /*#__PURE__*/_jsx(Icon, {
      size: "small",
      type: isOpen ? 'caret-up' : 'caret-down',
      isDisabled: isDisabled,
      isReadOnly: isReadOnly,
      color: "inherit"
    })
  });
};
TriggerRightElement.displayName = 'SelectNew.TriggerRightElement';
//# sourceMappingURL=TriggerRightElement.js.map